import React, { Component } from 'react';
import { base } from '../../base';
import SideMenu from '../admin/SideMenu';
import ExportCsv from '../utils/ExportCsv';
import '../../styles/css/AdminMain.css'

class AdminHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
          companyList: [],
          sessionResponses: [],
          sessionObject: {},
        };
    }

    componentWillMount() {
      this.companyListRef = base.bindToState(`companyList`, {
        context: this,
        state: 'companyList',
        asArray: true
      });
      this.sessionResponsesRef = base.bindToState(`sessionResponses`, {
        context: this,
        state: 'sessionResponses',
        asArray: true
      });
      this.sessionRef = base.bindToState(`sessionList`, {
        context: this,
        state: 'sessionObject',
      });
    }

    componentWillUnmount() {
      base.removeBinding(this.companyListRef);
      base.removeBinding(this.sessionResponsesRef);
      base.removeBinding(this.sessionRef)
    }

    render() {
      var companyList = this.state.companyList;
      var totalVotes = 0;
      if(companyList.length > 0){
        totalVotes = companyList.map(item => item.votes).reduce((prev, next) => prev + next);;
      }
      var sessionResponses = this.state.sessionResponses;
      var sessionObject = this.state.sessionObject;
      var sessionResponsesLength = sessionResponses.length;
        return (
          <div className="admin-wrapper">
            <SideMenu/>
            <div className="admin-main-panel">
              <h1>Home</h1>
              <div className="admin-grid-container admin-home">
                <div className="question-box">
                  <h4 className="header-stat">Total Company Votes</h4>
                  <p className="stat"><span>{totalVotes}</span></p>
                </div>
                {/*
                <div className="question-box">
                  <h4 className="header-stat">Total Session Responses</h4>
                  <p className="stat"><span>{sessionResponsesLength}</span></p>
                </div>*/}

                {
                  companyList.map(function(item, i){
                    return(
                      <div className="question-box" key={i}>
                        <h4 className="header-stat">{item.companyTitle}</h4>
                        <p className="stat"><span>{item.votes}</span></p>
                      </div>
                    )
                  })
                }
                {/*
                <ExportCsv data={sessionResponses} sessions={sessionObject}/>
                */}
              </div>
            </div>
         </div>
        );
    }
}

export default AdminHome



// WEBPACK FOOTER //
// ./src/components/admin/AdminHome.js